// src/App.jsx
import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";

import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import HomePage from "./pages/HomePage";
import AboutUsPage from "./pages/AboutUsPage";
import OurProductsPage from "./pages/OurProductsPage";
import SensaphonePage from "./pages/SensaphonePage";
import TraceTekPage from "./pages/TraceTekPage";
import RaychemPage from "./pages/RaychemPage";
import PicoBoxPage from "./pages/PicoBoxPage";
import DownloadsPage from "./pages/DownloadsPage";
import ContactUsPage from "./pages/ContactUsPage";
import SupportPage from "./pages/SupportPage";
import NewsPage from "./pages/NewsPage";
import NewsDetailPage from "./pages/NewsDetailPage";

import { useLocale } from "./contexts/LocaleContext";
import { useApiLoading } from "./contexts/LoadingContext";
import { setGlobalLoadingCallbacks } from "./api/axiosInstance";
import LoadingBackdrop from "./components/common/LoadingBackdrop";

function AppShell() {
  const { pathname } = useLocation();
  const { footerText, isLoadingSharedData } = useLocale();
  const { isApiLoading, _showApiLoadingInternal, _hideApiLoadingInternal } =
    useApiLoading();

  useEffect(() => {
    setGlobalLoadingCallbacks(_showApiLoadingInternal, _hideApiLoadingInternal);
    return () => {
      setGlobalLoadingCallbacks(
        () => {},
        () => {}
      );
    };
  }, [_showApiLoadingInternal, _hideApiLoadingInternal]);

  const mainSurfaceClass = "flex-grow page-canvas";

  return (
    <div className="font-sans flex flex-col min-h-screen">
      <Navbar />

      <main className={mainSurfaceClass}>
        <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about-us" element={<AboutUsPage />} />
            <Route
              path="/products/sensaphone/:itemPath"
              element={<SensaphonePage />}
            />
            {/* TraceTek: e.g. /products/tracetek/alarm/ttc-1 */}
            <Route
              path="/products/tracetek/:category/:itemPath"
              element={<TraceTekPage />}
            />
            <Route
              path="/products/raychem/:itemPath"
              element={<RaychemPage />}
            />
            {/* TraceTek: e.g. /products/tracetek/alarm, /products/tracetek/components */}
            <Route
              path="/products/tracetek/:category"
              element={<OurProductsPage />}
            />
            {/* PicoBox detail pages use their own URL prefix (set url in CMS accordingly) */}
            <Route
              path="/products/picobox/:itemPath"
              element={<PicoBoxPage />}
            />
            <Route path="/products/*" element={<OurProductsPage />} />
            <Route
              path="/products"
              element={<Navigate to="/products/sensaphone" replace />}
            />
            <Route path="/resources" element={<SupportPage />} />
            <Route path="/downloads/:brandSlug" element={<DownloadsPage />} />
            <Route path="/downloads" element={<DownloadsPage />} />
            <Route path="/manual/:brandSlug" element={<DownloadsPage />} />
            <Route path="/manual" element={<DownloadsPage />} />
            <Route path="/news" element={<NewsPage />} />
            <Route path="/news/:id" element={<NewsDetailPage />} />
            {/* <Route
              path="/case-study/:caseStudyName"
              element={<CaseStudyDetailPage />}
            /> */}
            <Route path="/contact-us" element={<ContactUsPage />} />
        </Routes>
      </main>

      {isLoadingSharedData ? (
        <footer className="bg-black text-white text-center p-6 mt-auto">
          Loading footer...
        </footer>
      ) : (
        <Footer copyrightText={footerText} />
      )}

      <LoadingBackdrop isLoading={isApiLoading} />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppShell />
    </Router>
  );
}

export default App;
